// extracted by mini-css-extract-plugin
module.exports = {"headline":"v_d4iB","title":"hz_UcV","continue_shopping":"s4Tt5A","continueShopping":"s4Tt5A","caret":"NqyxHZ"};